import React, { createContext, useReducer } from "react";

const initialState = {
    data: {},
    propertyList: [],
    loading: true,
    loadingPropertyList: true,
};

const portfolioReducer = (state = initialState, action) => {
    switch (action.type) {
        case "RESET_PORTFOLIO_PROPERTIES":
            const resetPortfolioProperties = { ...state };

            resetPortfolioProperties.loadingPropertyList = true;
            resetPortfolioProperties.propertyList = [];

            return resetPortfolioProperties;

        case "ADD_PORTFOLIO_PROPERTIES":
            const addPortfolioProperties = { ...state };

            addPortfolioProperties.propertyList = [
                ...state.propertyList,
                ...action.payload,
            ];

            return addPortfolioProperties;

        case "FETCH_PORTFOLIO_DETAILS":
            const updated_state1 = { ...state };

            updated_state1.loading = false;
            updated_state1.data = action.payload.data;

            return updated_state1;
            

        case "FETCH_PORTFOLIO_PROPERTIES_DETAILS":
            const updated_state2 = { ...state };
            const propertyQuickGet = action.payload.quickGet || false;

            updated_state2.loadingPropertyList = false;

            let currentPropertyList = updated_state2.propertyList || [];
            let fetchedPropertyList = action.payload?.data;
            let newPropertyList = []

            if (propertyQuickGet) {
                const existingIds = currentPropertyList.map(ppty => ppty.id);
                newPropertyList = fetchedPropertyList.filter(ppty => !existingIds.includes(ppty.id));
            } else {
                fetchedPropertyList.forEach(ppty => {
                    const index = currentPropertyList.findIndex(a => a.id === ppty.id);
                    if (index >= 0) {
                        currentPropertyList[index] = ppty;
                    } else {
                        newPropertyList.push(ppty);
                    }
                });
            }
            updated_state2.propertyList = [...currentPropertyList, ...newPropertyList];
            return updated_state2;
      
        case "CREATE_PROPERTY":
            const updated_state = { ...state };
            updated_state.propertyList = [...updated_state.propertyList, ...action.payload.new_properties];
            return updated_state;

        case "DELETE_PROPERTY":
            const { propertyId } = action.payload;

            const s = { ...state };
            s.propertyList =
                s.propertyList.filter(
                    (property) => property.id !== propertyId
                );

            return s;

        case "UPDATE_PROPERTY":
            const { property_id, updated_property } = action.payload;

            const state_new = { ...state, inFlight: false };
            state_new.propertyList =
                state_new.propertyList.map(
                    (property) => {
                        if (property.id === property_id) {
                            if (updated_property.name === '') {
                                updated_property.name = updated_property.address.street_line_1 + ', ' + updated_property.address.city + ', ' + updated_property.address.state;
                            }
                            return {
                                ...property,
                                ...updated_property,
                            };
                        } else {
                            return property;
                        }
                    }
                );

            return state_new;

        case "UPDATE_PORTFOLIO_BALANCES":
            let newBalances = {};
            let newState = { ...state };
            
            action.payload.allAccounts.forEach(account => {
                let purposeId = account.purpose.id;
                let accountBalance = account.account.aggregated_balance_raw;        
                if (newBalances.hasOwnProperty(purposeId)) {
                    newBalances[purposeId] += accountBalance;
                } else {
                    newBalances[purposeId] = accountBalance;
                }
            });
            
            state.propertyList.forEach(property => {
                Object.keys(property.balances).forEach(balanceType => {
                    if (newBalances.hasOwnProperty(balanceType)) {
                        newBalances[balanceType] += property.balances[balanceType];
                    } else {
                        newBalances[balanceType] = property.balances[balanceType];
                    }
                });
            });
            
            const infoBalances = newState.data?.info?.balances || {};
            Object.keys(infoBalances).forEach(key => {
                if (newBalances.hasOwnProperty(key)) {
                    newState.data.info.balances[key] = newBalances[key];
                }
            });
            
            return newState;
            
            

        case "ADD_BANK_ACCOUNT_PURPOSE":
            var newBankAccountPurpose = action.payload.bankAccountPurpose;
            var updatedState = { ...state };
            updatedState.data.info.balances = {
                ...updatedState.data.info.balances,
                [newBankAccountPurpose.id]: 0
            };
            updatedState.propertyList = updatedState.propertyList.map((property) => {
                return {
                    ...property,
                    balances: {
                        ...property.balances,
                        [newBankAccountPurpose.id]: 0
                    }
                };
            });
            return updatedState;       

        case "DELETE_BANK_ACCOUNT_PURPOSE":
            var deletedBankAccountPurpose = action.payload.bankAccountPurpose;
            var updatedState = { ...state };
            if (updatedState.data.info.balances[deletedBankAccountPurpose.id] === undefined) {
                return updatedState;
            }
            updatedState.data.info.balances = {
                ...updatedState.data.info.balances,
            };
            delete updatedState.data.info.balances[deletedBankAccountPurpose.id];
            updatedState.propertyList = updatedState.propertyList.map((property) => {
                const newProperty = { ...property };
                delete newProperty.balances[deletedBankAccountPurpose.id];
                return newProperty;
            });
            return updatedState;
               
        case "EDIT_BANK_ACCOUNT_PURPOSE":
            var editedBankAccountPurpose = action.payload.bankAccountPurpose;
            var updatedState = { ...state };
            updatedState.propertyList = updatedState.propertyList.map((property) => {
                return {
                    ...property,
                    balances: {
                        ...property.balances,
                        [editedBankAccountPurpose.id]: property.balances[editedBankAccountPurpose.id],
                    }
                };
            });
            return updatedState;     
            
        default:
            return state;
    }
};

const useThunkReducer = (reducer, initialState) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const enhancedDispatch = React.useCallback(
        (action) => {

            if (typeof action === "function") {
                action(dispatch);
            } else {
                dispatch(action);
            }
        },
        [dispatch]
    );

    return [state, enhancedDispatch];
};

export const PortfolioDetailsContext = createContext();


export const PortfolioDetailsProvider = ({ children }) => {
    const [state, dispatch] = useThunkReducer(portfolioReducer, initialState);

    return (
        <PortfolioDetailsContext.Provider
            value={{
                portfolioDetails: state,
                portfolioDetailsDispatch: dispatch,
            }}
        >
            {children}
        </PortfolioDetailsContext.Provider>
    );
};
